export const generalHeight = (width, data, aspectRation) => {
  var count = 0;

  for (let i = 0; i < data.length; i++) {
    if (!data[i].value) {
      count++;
    }
  }

  if (count === data.length) {
    return 50;
  } else {
    return width * aspectRation;
  }
};

export const colours = [
  "#ffcd00",
  "#ffa300",
  "#ff671f",
  "#fff68d",
  "#d6001c",
  "#ffbb6e",
  "#ffcb70",
  "#ff874f",
  "#fffabd",
];

// export const overviewColors = ["#d6001c", "#85ba51", "#2c5496"];
export const overviewColors = ["#d10000", "#85ba51", "#4d71bb"];
export const retrainingColors = [
  "#efad00",
  "#ffcd00",
  "#ffed40",
  "#fefeaf",
  //
  "#df470f",
  "#ff671f",
  "#ff9b4e",
  "#ffcb7e",
  //
  "#960000",
  "#d10000",
  "#f01010",
  "#ed6161",
  //
  "#ff9191",
];
export const productivityColors = ["#85ba51"];
export const systemColors = ["#0d318b", "#4d71bb", "#9dc3eb"];
export const benefitColors = ["#ffcd00", "#fefeaf", "#ff671f", "#ff9b4e", "#d10000", "#ed6161"];
// export const retrainingColors = benefitColors;
